import React, { useContext, useEffect, useState } from "react";
import { Badge, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AuthContext } from "../user/BCPAuthProvider";
import { BCPBagShopping } from "../icons/bcp/BCPIcons";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 10,
    top: 13,
    border: `2px solid ${theme?.palette?.background.paper}`,
    padding: "0 4px",
    minWidth: "25px",
    height: "25px",
    fontSize: "1rem",
    borderRadius: "15px",
  },
}));

export default function ShoppingBag() {
  var authContext = useContext(AuthContext);
  const [qty, setQty] = useState("");

  useEffect(() => {
    if (!authContext?.authState?.cart?.items?.length) {
      setQty(0);
      return;
    }
    var newQty = 0;
    authContext?.authState?.cart.items.forEach((item) => {
      newQty += item.qty;
    });
    setQty(newQty);
  }, [authContext]);

  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: 999,
        top: "80px",
        right: [35],
      }}
      href={"/shop/cart"}
      component="a"
    >
      <StyledBadge badgeContent={qty} color="primary">
        <BCPBagShopping color="action" style={{ "font-size": 55, width: 55 }} />
      </StyledBadge>
    </Box>
  );
}
